import angular from 'angular';
import { FilterComponent } from './filter.component';
import { FilterService } from './filter.service';
export var FilterModule = angular
    .module('directives.productFilter', [])
    .component('productFilter', FilterComponent)
    .service('FilterService', FilterService)
    .name;
//# sourceMappingURL=filter.module.js.map